import React from 'react';
import { ConversationMessage } from '@zonofi/zono-money-store';
import { MessageCard } from '../message-card/message-card';
import './message-list.scss';
import { ListSkeleton } from '../../components';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { isEmpty } from 'lodash';
import { MessagePayload } from '@zonofi/common';

interface MessageListProps {
  data: ConversationMessage[];
  isLoading: boolean;
  oldestFirst?: boolean;
  setOldestFirst?: (val: boolean) => void;
}

export const MessageList: React.FC<MessageListProps> = ({
  data,
  isLoading,
  oldestFirst = false,
  setOldestFirst = () => {},
}) => {
  return (
    <div className="conversation-msg-list">
      <div className="conversation-msg-list-header font-semibold">
        <span>Messages</span>
        <span
          className="sort-order"
          onClick={() => setOldestFirst(!oldestFirst)}
        >
          {!oldestFirst ? 'Latest First' : 'Oldest First'}{' '}
          {!oldestFirst ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
        </span>
      </div>
      {data.map(
        (
          {
            isInternalNote,
            pubnubMessage,
            timetoken,
            stats,
            message,
            chatId,
            isWidgetChat,
          },
          index
        ) => (
          <MessageCard
            key={`${timetoken}-${index}`}
            message={
              (isInternalNote && isEmpty(pubnubMessage)
                ? message
                : pubnubMessage) as MessagePayload
            }
            timetoken={timetoken}
            stats={stats}
            isInternalNote={isInternalNote}
            isWidgetChat={isWidgetChat}
            chatId={chatId}
          />
        )
      )}
    </div>
  );
};
